export default __webpack_public_path__ + "static/media/emergency_number.30ba1c3a.svg";